import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CareerPositionCard, CareerPositionCardLayoutData, CareerPositionLabelViewType, CareerPositionType } from '../career-lobby-page.interfaces';

@Component({
  selector: 'app-career-lobby-position-item',
  templateUrl: './career-lobby-position-item.component.html',
  styleUrls: ['./career-lobby-position-item.component.scss', './career-lobby-position-item.component.en.scss'],
})
export class CareerLobbyPositionItemComponent implements OnInit {
  @Input() cardData!: CareerPositionCard;
  @Input() layoutData!: CareerPositionCardLayoutData;
  labelText: string = 'extern';
  labelClass: string = 'outline';
  careerPositionType!:CareerPositionType;


  ngOnInit(): void {
    this.setLabelType();
  }

  setLabelType() {
    switch (this.cardData.type) {
      case CareerPositionType.Internal:
        this.labelText = this.layoutData.iternalPositionLabelText;
        this.labelClass = this.getLabelTypeClass(this.layoutData.iternalPositionLabelType);
        break;
      case CareerPositionType.External:
        this.labelText = this.layoutData.externalPositionLabelText;
        this.labelClass = this.getLabelTypeClass(this.layoutData.externalPositionLabelType);
        break;
      case CareerPositionType.AssistantsResearch:
        this.labelText = this.layoutData.researchAssistancePositionLabelText;
        this.labelClass = this.getLabelTypeClass(this.layoutData.researchAssistancePositionLabelType);
        break;
      default:
        this.labelText = this.layoutData.iternalPositionLabelText;
        break;
    }
  }

  getLabelTypeClass(labelViewType: CareerPositionLabelViewType) {
    switch (labelViewType) {
      case CareerPositionLabelViewType.DarkFill:
        return "";
      case CareerPositionLabelViewType.LightFill:
        return "light-fill";
      case CareerPositionLabelViewType.LightBorder:
        return "outline";
      default:
        return "";
    }
  }
}
